export const SET_FUNCIONARIO = 'pages/cadastroFuncionario/SET_FUNCIONARIO'
export const CLEAR_FUNCIONARIO = 'pages/cadastroFuncionario/CLEAR_FUNCIONARIO'
export const ADD_MATRICULA = 'pages/cadastroFuncionario/ADD_MATRICULA'
export const UPDATE_MATRICULA = 'pages/cadastroFuncionario/UPDATE_MATRICULA'
export const REMOVE_MATRICULA = 'pages/cadastroFuncionario/REMOVE_MATRICULA'
